/**
 * Returns the base URL for Firebase Cloud Functions.
 * Automatically switches between local emulator and production.
 */
const PROJECT_ID = import.meta.env.VITE_FIREBASE_PROJECT_ID || 'storybook-wizard-452216';
const REGION = 'us-central1';
const USE_EMULATORS = import.meta.env.VITE_USE_EMULATORS === 'true';

const EMULATOR_BASE = `http://127.0.0.1:5001/${PROJECT_ID}/${REGION}`;
const CLOUD_BASE = `https://${REGION}-${PROJECT_ID}.cloudfunctions.net`;

export const FUNCTIONS_BASE_URL = USE_EMULATORS ? EMULATOR_BASE : CLOUD_BASE;

export function getCloudFunctionUrl(functionName) {
  return `${FUNCTIONS_BASE_URL}/${functionName}`;
}
